import VueSetup from "../../../../contents/docs/integrate/_snippets/vuejs/vue-setup.mdx";
import * as React from 'react';
export default {
  VueSetup,
  React
};